import { render, staticRenderFns } from "./SjtuFeedback.vue?vue&type=template&id=6d590869&scoped=true&"
import script from "./SjtuFeedback.vue?vue&type=script&lang=ts&"
export * from "./SjtuFeedback.vue?vue&type=script&lang=ts&"
import style0 from "./SjtuFeedback.vue?vue&type=style&index=0&id=6d590869&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d590869",
  null
  
)

export default component.exports